import { isNil } from '@/utilities/fp';
import type {
  TimeSeriesRawData,
  SafeTimeSeriesRawData,
} from '@/pages/CompanyReport/components/Past/hooks/useCompanyTimeSeries/queryFn';

export const getFreeCashFlowDifference = (
  earnings: number | null,
  depAndAmort: number | null,
  stockBasedComp: number | null,
  netWorkingCapital: number | null,
  freeCashFlow: number | null
) => {
  if (
    isNil(earnings) ||
    isNil(depAndAmort) ||
    isNil(stockBasedComp) ||
    isNil(netWorkingCapital) ||
    isNil(freeCashFlow)
  ) {
    return null;
  }

  const increments =
    earnings + depAndAmort + stockBasedComp + netWorkingCapital;

  return freeCashFlow - increments;
};

export const isSufficientData = (
  rawData: TimeSeriesRawData
): rawData is SafeTimeSeriesRawData => {
  return (
    rawData !== null &&
    rawData.timeSeries !== null &&
    rawData.timeSeries.length > 0
  );
};
